import { render, staticRenderFns } from "./m_esg024.vue?vue&type=template&id=1347c085&scoped=true&"
import script from "./m_esg024.vue?vue&type=script&lang=js&"
export * from "./m_esg024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347c085",
  null
  
)

export default component.exports